import { OPEN_CTA_PROMPT } from 'aria-viewer/ctaPrompt/ctaPromptActions'
import { trackEvent } from 'aria-viewer/core/middleware/analyticsMiddleware'
import * as EVENTS from 'aria-viewer/analytics/constants/mobileAnalytics'
import { getTourData } from 'aria-viewer/analytics/utils/analyticUtils'
import CTAPromptTypes from 'aria-viewer/tour/constants/CTAPromptTypes'

const ctaPromptAnalytics = {
    [OPEN_CTA_PROMPT]: (getState, action) => {
        const { loc_name, inst_name, stoptitle, userkey } = getTourData()(getState)
        const { promptType } = action

        return trackEvent(promptType == CTAPromptTypes.ACT_NOW ? EVENTS.M_ACTNOW_VIEWED : EVENTS.M_WHATSNEXT_VIEWED, {
            Institution: inst_name,
            Location: loc_name,
            Stop: stoptitle,
            Userkey: userkey,
        })
    },
}

export default ctaPromptAnalytics
